// SmartGroups.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function SmartGroups() {
    return (
        <PageLayout title="SmartGroups" subtitle="SmartGroups overview">
            <div className="container flex col box-container">
                {/* <div className="box">SmartGroups</div> */}
            </div>
        </PageLayout>   
    );
}

export default SmartGroups;